import {Component, inject, ViewChild} from '@angular/core'; //
import {PageGridComponent} from 'src/app/shared/components/page-grid/page-grid.component';
import {GridModel} from 'src/app/shared/model/page-grid';
import {FinanceFilterModel} from '../../models/finance-filter-model';
import {FinanceFilterModalService} from '../../service/finance-filter-modal.service';
import {GetSubmitToSalesActivityReportResponse, SubmitToSalesActivityReportResponse} from '../../models/submit-to-sales-activity-report-response';
import {SalesActivitySubmitToService} from '../../service/sales-activity-submit-to.service';


@Component({
    selector: 'app-sales-activity-submit-to-list',
    templateUrl: './sales-activity-submit-to-list.component.html',
    standalone: false
})

export class SalesActivitySubmitToListComponent{
  @ViewChild(PageGridComponent) protected salesActivitySubmitToListRef!: PageGridComponent;

  constructor(
    private financeFilterModalService: FinanceFilterModalService
    ) { 
      this.financeFilterModalService.getFilters().subscribe((filter: FinanceFilterModel) => {
            const {
                TravelTypeIds,
                SubmitToList,
                IssueDateFrom,
                IssueDateTo,
                DataSourceId,
                BranchIds,
                ReloadGrid
            } = filter;

            this.submitToGrid.filtersInitial = {
                TravelTypeIds,
                SubmitToList,
                IssueDateFrom: new Date(IssueDateFrom).toISOString(),
                IssueDateTo: new Date(IssueDateTo).toISOString(),
                DataSourceId,
                BranchIds,
                ReloadGrid
            }

            if(filter.ReloadGrid) {
              this.salesActivitySubmitToListRef?.getItems();
            }
          });
    }

  protected readonly submitToGrid: GridModel<GetSubmitToSalesActivityReportResponse> = {
    gridDataTestId: 'sales-activity-report-submit-to-list',
    gridTitle: 'Sales Activity Report - Submit To',
    defaultPageSize: 5, 
    replayButton: true,
    singleColumnFilter: true,
    columns: [
      {
        columnProperty: 'submitToLink',
        columnHeader: 'Submit To',
        sort: true,
        clickable: false,
      },
      {
        columnProperty: 'submitToPercentToTotalFare',
        columnHeader: '% Total',
        sort: true,
        columnPropertyFunction: (item: SubmitToSalesActivityReportResponse) => `${item.submitToPercentToTotalFare ?? ''}`,
      },
      {
        columnProperty: 'submitToPercentYield',
        columnPropertyFunction: (item: SubmitToSalesActivityReportResponse) => `${item.submitToPercentYield ?? ''}`,
        columnHeader: '% Yield',
        sort: true,
      },
      {
        columnProperty: 'submitToTotalFareSum',
        columnPropertyFunction: (item: SubmitToSalesActivityReportResponse) => `${item.submitToTotalFareSum ?? ''}`,
        columnHeader: 'Total Fare',
        sort: true,
      },
      {
        columnProperty: 'submitToNetFareSum',
        columnHeader: 'Net Fare',
        sort: true,
      },
      {
        columnProperty: 'submitToCommAmountSum',
        columnHeader: 'Commission',
        sort: true,
      },
      {
        columnProperty: 'submitToPercentComm',
        columnHeader: '% Comm',
        sort: true,
      },
    ],
    gridGetService: inject(SalesActivitySubmitToService)
  };
}